(function() {
  'use strict';
  
  if (window.__lcpPosterInit) return;
  window.__lcpPosterInit = true;
  
  function init() {
    // 找到所有 LCP poster 图片
    var posters = document.querySelectorAll('.video-poster-lcp');
    
    document.querySelectorAll('.slideshow__video video').forEach(function(video) {
      var container = video.closest('.slideshow__video');
      if (!container) return;
      
      // 在同一个容器里找 poster
      var poster = container.querySelector('.video-poster-lcp');
      if (!poster) return;
      
      function hidePoster() {
        if (poster.dataset.hidden) return;
        poster.dataset.hidden = 'true';
        poster.style.opacity = '0';
        // 保持全屏，只是透明
      }
      
      video.addEventListener('play', hidePoster);
      video.addEventListener('playing', hidePoster);
      
      if (video.currentTime > 0) {
        hidePoster();
      }
      
      video.addEventListener('timeupdate', function() {
        if (video.currentTime > 0.1) {
          hidePoster();
        }
      });
      
      // 2秒后隐藏
      setTimeout(hidePoster, 2000);
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();